export default {
  name: 'CaseOwnerProfileModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object,
      default: () => ({})
    },
    saveVersion: {
      type: Number,
      default: 0
    }
  },
  emits: ['close', 'save-profile'],
  data() {
    const state = {
      editing: false,
      edit_form: profile_edit_form(),
    };
    return state;
  },
  computed: {
    metric_cards() {
      return Array.isArray(this.profile.metric_cards) ? this.profile.metric_cards : [];
    },
    contact_rows() {
      return Array.isArray(this.profile.contact_rows) ? this.profile.contact_rows : [];
    },
    specialties() {
      return Array.isArray(this.profile.specialties) ? this.profile.specialties : [];
    },
    case_snapshot() {
      return Array.isArray(this.profile.case_snapshot) ? this.profile.case_snapshot : [];
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.reset_edit_form();
      }
    },
    profile: {
      deep: true,
      handler() {
        if (!this.editing) {
          this.reset_edit_form();
        }
      }
    },
    saveVersion() {
      this.editing = false;
      this.reset_edit_form();
    }
  },
  methods: {
    close_modal() {
      this.editing = false;
      this.$emit('close');
    },
    cancel_edit() {
      this.editing = false;
      this.reset_edit_form();
    },
    save_profile() {
      this.$emit('save-profile', { ...this.edit_form });
    },
    reset_edit_form() {
      this.edit_form = profile_edit_form(this.profile?.edit_profile || {});
    }
  }
};

function profile_edit_form(profile = {}) {
  return {
    user_id: profile.user_id || '',
    first_name: profile.first_name || '',
    last_name: profile.last_name || '',
    email: profile.email || '',
    phone_number: profile.phone_number || '',
    role_id: profile.role_id || '',
  };
}
